import { Component, OnInit } from '@angular/core';
import { AdminService } from 'app/admin/admin.service';
import { INofshonCharig} from 'app/admin/interface/nofshon-charig.interface';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { Router } from '@angular/router';
import { SpinnerService } from 'app/shared/spinner/spinner.service';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';

interface IKeyValue
{
  key: number;
  value: string;
}

@Component({
  selector: 'app-nofshonim-charigim',
  templateUrl: './nofshonim-charigim.component.html',
  styleUrls: ['./nofshonim-charigim.component.css']
})
export class NofshonimCharigimComponent implements OnInit {
  
  constructor
  (private _adminService : AdminService,
   private fb :FormBuilder,
   private dialog: MatDialog,
   private confirmService : ConfirmService,
   private userMessage : UserMessagesService,
   private router : Router,
   private spinnerService: SpinnerService
  ){ }
  
  currentIdNofesh : number;
  nofshonimCharigim : INofshonCharig[];
  filteredNofshonimCharigim : INofshonCharig[] = [];
  nofeshTitles: IKeyValue[] = [
    { key: 0, value: "הכל" }
  ];

  charigimForm = this.fb.group({
    nofeshTitle:[0],
  })
  ngOnInit() {
    this.spinnerService.showSpinner();
    this._adminService.getNofshonimCharigim().subscribe(res=>{
      this.nofshonimCharigim  = res.data;
      this.spinnerService.hideSpinner();
       Object.assign(this.filteredNofshonimCharigim, this.nofshonimCharigim);
      this.filterNofashimCharigimTitles();

     })
  }


  filterNofashimCharigimTitles(): void
  {
    this.nofshonimCharigim.forEach((nofeshCharig, index) => {
      if(nofeshCharig.nofeshTitle != this.nofeshTitles[this.nofeshTitles.length - 1].value)
      {
        this.nofeshTitles.push({ key: nofeshCharig.idNofesh, value: nofeshCharig.nofeshTitle });
      }
    });
  }

  filterNofshonim()
  {
    if(this.charigimForm.value.nofeshTitle == 0) // all nofashim
    {
      Object.assign(this.filteredNofshonimCharigim, this.nofshonimCharigim);
    }
    else
    {
      this.filteredNofshonimCharigim = this.nofshonimCharigim.filter(data=>data.idNofesh == this.charigimForm.value.nofeshTitle);
    }
  }

  deleteNofesh(nofesh: INofshonCharig,filteredIndex:number)
  {
    this.userMessage.clearAll();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {title : "מחיקת נופשון לעובד",text:"האם אתה בטוח שברצונך למחוק את הנופשון לעובד?"}
    let dialogRef = this.dialog.open(ConfirmDialogComponent,dialogConfig);

    //let isDeleted : boolean  = false;
    let deleteResult: ResultOfOperation<object>
    let confirmSubscription = this.confirmService.confirm$.subscribe((confirm:boolean) => {
      if(confirm)
      {
        this.spinnerService.showSpinner();
        this._adminService.deleteNofshonCharig(nofesh).subscribe(res => {
          this.spinnerService.hideSpinner();
          deleteResult = res;
          if(res.isSuccess)
          {
            let index: number  = this.nofshonimCharigim.findIndex((element: INofshonCharig) => {
              let result = false;
            
              if(element.idNofesh == nofesh.idNofesh && element.msZehutMazmin == nofesh.msZehutMazmin)
              {
                result = true;
              }
              return result;
            });
            if(index >= 0)
            {
              debugger;
              let nofshonToDelete = this.nofshonimCharigim.splice(index, 1);
              this.filteredNofshonimCharigim.splice(filteredIndex,1);
            }
          }
          confirmSubscription.unsubscribe();
          dialogRef.close();
        })
      }
    });


    dialogRef.afterClosed().subscribe(_ => {
      if(deleteResult && deleteResult.isSuccess)
      {
        this.userMessage.setSuccessMessage(deleteResult.message);
      }
      else if(deleteResult && !deleteResult.isSuccess)
      {
        this.router.navigateByUrl("admin/nofshonim-admin/nofshonim-charigim");
        this.userMessage.setErrorMessage(deleteResult.message);
      }
      else
      {
        this.router.navigateByUrl("admin/nofshonim-admin/nofshonim-charigim");
        //this.userMessage.setErrorMessage("בעיה במחיקת נופשון, אנא נסה שוב מאוחר");
      }
    });

  }
}
